import NoteHelper from './NoteHelper'
import firestore from '../../store/firestore'
import store from '../../store'

const _noteHelpers = {}
// window._noteHelpers = _noteHelpers

/**
 * Retrieves all note helpers.
 * @returns []
 */
export function allNoteHelpers () {
  return Object.values(_noteHelpers)
}

/**
 * Finds a note helper.
 * @param noteId  string  The id of the note to find.
 * @returns {*} or undefined if the noteHelper does note exits
 */
export function findNoteHelper (noteId) {
  return _noteHelpers[noteId]
}

/**
 * Finds children note helpers of noteId
 * @param noteId the parent to search for children in
 * @param allChildren if true, search recursively, if false, just one layer deep
 */
export function getChildren (noteId, allChildren = false) {
  const parent = findNoteHelper(noteId)
  return parent.children(true)
}

/**
 * Creates a new note
 * @param noteData  the data to be contained in the note
 * @param parentId  the note's parent
 * @returns {Promise<NoteHelper | never>}
 */
export function createNewNote (noteData, parentId) {
  if (parentId === undefined) parentId = null
  let promises = []
  let parentNoteHelper = findNoteHelper(parentId)
  if (parentId != null && !parentNoteHelper) throw new Error('Parent note did not exist.')
  let ref = firestore.itemsColRef.doc()
  noteData.id = ref.id
  let noteHelper = new NoteHelper(noteData)
  _noteHelpers[ref.id] = noteHelper
  promises.push(noteHelper.newNoteToFirestore(noteData))
  if (parentId != null) {
    promises.push(parentNoteHelper.addNoteToChildren(ref.id))
    parentNoteHelper.formattedTreeItem.children.push(noteHelper.getFormattedTreeItem())
  } else {
    promises.push(store.dispatch('addRootChild', { childId: ref.id }))
  }
  return Promise.all(promises).then(() => Promise.resolve(noteHelper))
}

/**
 * Finds a note helper and if it doesn't exist, creates one and adds it to
 * the _noteHelpers array.
 * @param firestoreNoteObj  {*} A note object directly from firestore add/modify.
 * @returns {*}
 */
export function findOrCreateNoteHelper (firestoreNoteObj) {
  console.log('FOCNoteHelper')
  if (!('id' in firestoreNoteObj)) throw new Error('Invalid note object passed.')
  let noteHelper = findNoteHelper(firestoreNoteObj.id)
  if (!noteHelper) {
    noteHelper = new NoteHelper(firestoreNoteObj)
    _noteHelpers[firestoreNoteObj.id] = noteHelper
  }
  return noteHelper
}

/**
 * Removes a noteHelper from the array.
 * Does not destroy or clean up the noteHelper.
 * You probably shouldn't be calling this manually, instead
 * call noteHelper.destroy().
 * @param noteId  string  The id of the note to remove
 */
export function _removeNoteHelper (noteId) {
  delete _noteHelpers[noteId]
}
